var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroShapeBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 664,
    viewBox: "0 0 572 664",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_113_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 572,
    height: 664
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 572,
    height: 664,
    fill: "#C7D2FE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_113_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.051 591.466C467.434 563.251 474.912 521.768 475.281 482.632C476.314 373.03 514.242 359.472 554.918 278.309C603.262 181.615 533.828 127.714 462.932 121.234C433.669 118.823 402.476 117.912 380.068 95.9217C362.58 78.8078 354.986 49.0525 343.976 26.9847C303.723 -52.9569 197.096 -74.7739 120.784 44.2847C75.6578 114.757 83.3079 172.362 90.4254 252.083C97.1325 327.241 70.4009 384.011 32.9465 447.551C-56.4219 598.991 45.8603 794.273 287.859 610.328C325.655 581.638 381.941 614.315 420.051 591.466Z",
    fill: "#FFBD2E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroShapeBg2);
export default __webpack_public_path__ + "static/media/hero-shape-bg2.1af5bba1f9b4bfdb21e5fadc49753bb9.svg";
export { ForwardRef as ReactComponent };